import { useEffect, useState } from 'react';

/**
 * A value that settles before anything acts on it.
 *
 * Search boxes here filtered whatever had already been fetched, so typing cost nothing and
 * answered the wrong question. Searching the whole set means asking the server, and asking
 * on every keystroke would be a request per letter. This holds the value until the typing
 * stops.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
